import React from "react";
import './App.css'
const Header = () => {
  return (
    // div for the head of main page 
    <div className="head-con">
      <div >
        <h2 className="heading">
        Contacts Book
        </h2>
      </div>
    </div>
  );
};

export default Header;
